import React, { useEffect } from 'react';
import { useState } from 'react';
import { store } from 'components/Store';
import { useContext } from 'react';
import SearchBarWithEmailPerformance from './SearchBarWithEmailPerformance';
import useEmailComponentFunctions from 'components/Dashboard/Influence/CrmEmails/useEmailComponentFunctions';
import { useEmailState } from 'components/EmailStateProvider';
import { useNavigate, useParams, useLocation } from 'react-router';
import time from 'utils/time';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';

const EngagementStatisticsDropdown = () => {
  const globalState = useContext(store);
  const { state: globalStateValue } = globalState;
  const { listDomainsVerified } = globalStateValue;

  const [sentEmails, setSentEmails] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const params = useParams();
  const { crmEmailId } = params;

  const { loadSentEmails } = useEmailComponentFunctions();
  const { setEmailState } = useEmailState();
  const { addMetaTags } = useAddMetaTags();

  const showSearchBarCondition =
    sentEmails.length > 0 || listDomainsVerified?.verifiedDomains?.some((domain) => domain?.sentEmailCount > 0);

  // INITIAL LOAD
  useEffect(() => {
    const source = new AbortController();
    loadSentEmails({ setSentEmails, source });
    return () => {
      source.abort('Email performance api call canceled by the user');
    };
  }, []);

  useEffect(() => {
    if (!crmEmailId && !!sentEmails.length) {
      navigate(`/people/email-performance/${sentEmails[0].crmEmailId}`);
      return;
    }

    if (crmEmailId && sentEmails.length) {
      setEmailState('emailPerformanceOnLoad', false);
    }
  }, [sentEmails, crmEmailId, location.pathname, navigate, setEmailState]);

  useEffect(() => {
    if (crmEmailId) {
      let title = `Email performance - Influence - PolicyMogul`;
      addMetaTags({ title, hash: null });
    }
  }, [crmEmailId]);

  const selectedEmail = sentEmails.find((item) => item.crmEmailId === parseFloat(crmEmailId));
  let buttonText = `Sent on ${time(selectedEmail?.finishedSendingAt).formatShortDate()} at ${time(selectedEmail?.finishedSendingAt).format('H:mm')}`;

  return showSearchBarCondition ? (
    <div className='flex-centered flex-grow-1 justify-content-between'>
      <SearchBarWithEmailPerformance sentEmails={sentEmails} isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className='d-md-block d-none ml-3'>
        <span
          className={`crm-table-item-state nowrap-item sent-state-badge border email-state-sent w-auto px-4 ${!selectedEmail?.finishedSendingAt ? 'text-transparent' : ''}`}
          style={{ fontSize: '16px' }}
        >
          {buttonText}
        </span>
      </div>
    </div>
  ) : (
    <div className='flex-grow-1'></div>
  );
};

export default EngagementStatisticsDropdown;
